import { createTheme } from '@mui/material'

/**
 * Global theme applied to all Material UI components in the app
 */
export const AppTheme = createTheme({ palette: { mode: 'dark' } })
